//TODO: 추후 삭제처리

import { alertTypeObj } from '@models/manager/account/account';
import AlertList from '@components/template/account/alert';
import CreateAlertBox from '@components/template/account/alert/createAlertBox';
import HistoryBox from '@components/template/account/alert/historyBox';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';

const AlertManager = () => {
  const { alertBoxType } = useSelector(({ alert }: RootState) => alert);

  return (
    <>
      {alertBoxType === alertTypeObj.listBox && <AlertList />}
      {alertBoxType === alertTypeObj.createBox && <CreateAlertBox />}
      {alertBoxType === alertTypeObj.historyBox && <HistoryBox />}
    </>
  );
};

export default AlertManager;
